import { render, staticRenderFns } from "./cfsInboundSearch.vue?vue&type=template&id=dd48d23e&scoped=true"
import script from "./cfsInboundSearch.vue?vue&type=script&lang=js"
export * from "./cfsInboundSearch.vue?vue&type=script&lang=js"
import style0 from "./cfsInboundSearch.vue?vue&type=style&index=0&id=dd48d23e&prod&scoped=true&lang=css"
import style1 from "./cfsInboundSearch.vue?vue&type=style&index=1&id=dd48d23e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd48d23e",
  null
  
)

export default component.exports